import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import facialSense_logo from "../../../assets/images/logo/CheckIDBioSense_light.svg";
import notfound_logo from "../../../assets/images/logo/notfound.svg";

import US from "../../../assets/images/flag/US.png";
import VN from "../../../assets/images/flag/VN.png";

import { ControlpanelPrimaryButton } from "../../../components/StyledButton";

import RefreshCircleIcon20pxSvgV2 from "../../../assets/images/icons/RefreshCircleIcon20pxSvgV2";
import { IoIosArrowRoundBack } from "react-icons/io";

const NotFoundPage = () => {
    const { t, i18n } = useTranslation();

    const [openLang, setOpenLang] = useState(false);

    const languages = [
        { code: "vi", label: "Tiếng Việt" },
        { code: "en", label: "English" },
    ];

    const currentLang =
        languages.find((l) => l.code === i18n.language)?.label || "Language";

    const changeLang = (code) => {
        i18n.changeLanguage(code);
        setOpenLang(false);
    };

    const handleRefresh = () => {
        window.location.reload();
    };

    const handleBackHome = () => {
        window.location.href = `${window.location.origin}/portal/login`;
    };

    return (
        <div className="min-h-screen flex flex-col px-4">
            {/* HEADER */}
            <div className="w-full flex items-center justify-between py-4">
                {/* Logo */}
                <img
                    src={facialSense_logo}
                    alt="logo"
                    className="h-14 w-auto"
                />

                {/* Language */}
                <div className="relative">
                    <button
                        onClick={() => setOpenLang((prev) => !prev)}
                        className="
                            flex items-center gap-2
                            px-3 py-2
                            border border-[#E5E7EB]
                            rounded-xl
                            bg-white
                            hover:bg-gray-50
                            transition
                        "
                    >
                        <img
                            src={i18n.language === "vi" ? VN : US}
                            alt="flag"
                            className="w-6 h-6 rounded-full object-cover"
                        />

                        <span className="text-sm text-gray-700">
                            {currentLang}
                        </span>

                        <svg
                            className={`w-4 h-4 transition-transform ${openLang ? "rotate-180" : ""
                                }`}
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                fillRule="evenodd"
                                d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </button>

                    {/* Dropdown */}
                    {openLang && (
                        <div
                            className="
                                absolute right-0 mt-2 w-40
                                bg-white
                                border border-[#E5E7EB]
                                rounded-lg
                                shadow-lg
                                z-50
                                overflow-hidden
                            "
                        >
                            {languages.map((lang) => (
                                <button
                                    key={lang.code}
                                    onClick={() => changeLang(lang.code)}
                                    className={`
                                        w-full text-left px-3 py-2 text-sm
                                        hover:bg-gray-100
                                        ${i18n.language === lang.code
                                            ? "bg-gray-50 font-semibold"
                                            : ""
                                        }
                                    `}
                                >
                                    {lang.label}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {/* CONTENT */}
            <div className="flex-1 flex items-center justify-center">
                <div
                    className="
                        w-full max-w-6xl
                        flex flex-col-reverse lg:flex-row
                        items-center justify-center
                        gap-10 lg:gap-20
                    "
                >
                    {/* LEFT */}
                    <div className="flex flex-col items-center lg:items-start text-center lg:text-left max-w-xl space-y-6">
                        <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
                            {t("common.page-not-found")}
                        </h1>

                        <p className="text-[#6B7280] text-base md:text-lg">
                            {t("common.page-not-found-description")}
                        </p>

                        <div className="flex flex-col sm:flex-row items-center gap-4">
                            <ControlpanelPrimaryButton
                                onClick={handleRefresh}
                                sx={{ textTransform: "none" }}
                            >
                                <RefreshCircleIcon20pxSvgV2 color="#FCFCFC" />

                                <p>{t("button.refresh-data")}</p>
                            </ControlpanelPrimaryButton>
                        </div>

                        <div>
                            <button
                                onClick={handleBackHome}
                                className="
                                    flex items-center
                                    text-blue-600
                                    hover:underline
                                    transition
                                "
                            >
                                <IoIosArrowRoundBack
                                    size={22}
                                    className="mr-1"
                                />

                                {t("common.back-to-home")}
                            </button>
                        </div>
                    </div>

                    {/* RIGHT IMAGE */}
                    <div className="flex justify-center">
                        <img
                            src={notfound_logo}
                            alt="Not Found"
                            className="
                                w-[260px]
                                sm:w-[320px]
                                md:w-[420px]
                                lg:w-[500px]
                                h-auto
                                object-contain
                            "
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;